var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { getTrackerProps } from '../../common/tracking/getTrackerProps';
import { display, space, themeGet } from 'styled-system';
import { withLocale } from '../../common/providers/LocaleProvider';
import { Link } from '../../common/components/Link';
var LanguageSwitchWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  align-self: flex-end;\n  flex: none;\n"], ["\n  ", ";\n  ", ";\n  align-self: flex-end;\n  flex: none;\n"])), display, space);
LanguageSwitchWrapper.defaultProps = {
    display: ['none', null, 'inline-flex'],
    ml: [null, 2, '12px'],
};
var LanguageSelector = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  font-weight: ", ";\n  cursor: pointer;\n\n  &:not(:first-of-type) {\n    ", ";\n\n    &:before {\n      content: '';\n      display: inline-block;\n      width: 1px;\n      height: 8px;\n      margin-right: ", "px;\n      background-color: currentColor;\n    }\n  }\n\n  ", ";\n"], ["\n  position: relative;\n  font-weight: ", ";\n  cursor: pointer;\n\n  &:not(:first-of-type) {\n    ", ";\n\n    &:before {\n      content: '';\n      display: inline-block;\n      width: 1px;\n      height: 8px;\n      margin-right: ", "px;\n      background-color: currentColor;\n    }\n  }\n\n  ",
    ";\n"])), function (props) { return (props.current ? 'bold' : 'normal'); }, space, themeGet('space.1'), function (props) {
    return props.current &&
        "\n    &:hover,\n    &:active,\n    &:focus {\n      color: currentColor;\n      text-decoration: none;\n      cursor: initial;\n    }\n  ";
});
LanguageSelector.defaultProps = {
    as: Link,
    pl: 1,
    fontSize: 2,
    lineHeight: 2,
};
var LanguageSwitch = function (_a) {
    var l10n = _a.l10n;
    var languages = l10n.languages().map(function (item) { return (__assign(__assign({}, item), { language: l10n.t("h24_language_" + item.language + "_short") })); });
    return languages && languages.length > 1 ? (React.createElement(LanguageSwitchWrapper, null, languages.map(function (_a) {
        var language = _a.language, pathPrefix = _a.pathPrefix, isCurrent = _a.isCurrent;
        return (React.createElement(LanguageSelector, __assign({ key: language }, getTrackerProps({
            'data-testid': 'language-selector-link',
            href: isCurrent ? '#' : pathPrefix + "/",
            current: isCurrent,
        }, {
            event: 'headerTracking',
            eventData: {
                placement: 'header',
                labelIdentifier: 'languageSelector',
            },
        })), language));
    }))) : null;
};
LanguageSwitch.propTypes = {
    /** Locale context. */
    l10n: PropTypes.object,
};
export default withLocale(LanguageSwitch);
var templateObject_1, templateObject_2;
